export default __webpack_public_path__ + "/dist/images/alysei-icon-only.4de8f9436f8c3a67f203ed8a6ea84b7c.png";